<!--时间排班模板-->
<template>
  <div class="app-container" ref="appRef">
    <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleChangeTab">
      <el-tab-pane label="排班模板设置" name="first"> -->
    <!-- <div class="title-container" shadow="never" style="margin-top: -10px;">
          <div class="title-con">
            <i class="el-icon-set-up"></i>
            <span style="margin-left: 5px;">操作</span>
          </div>
        </div> -->
    <div v-if="ReleaseLesson">
      <el-card class="operate-container" shadow="never" style="margin-top: 0px;border: none;">
        <div class="top-con" style="width: 100%;">
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-circle-plus-outline"
            @click="ReleaseLesson = false">课程记录</el-button>
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-circle-plus-outline"
            @click="schedule = true">创建课表</el-button>
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-circle-plus-outline"
            @click="handleAddoneDlg()">添加课程</el-button>
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-circle-plus-outline"
            @click="clickRemovedt">删除</el-button>
          <!-- <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-circle-plus-outline"
            @click="handleAddoneDlg()">刷新</el-button> -->
          <!-- <div style="margin-left: 30px; font-size: 14px;">选择课表:</div>
          <el-select v-model="queryParam.name" placeholder="请选择" @change="onChaneTemplate" style="margin-left: 10px;">
            <el-option v-for="item in allScheTemplates" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select> -->
          <div class="spec-buton-box" style="margin-left: 60px;">
            <el-button type="primary" class="operator-btn" @click="copyOtherTemplate()"
            >拷贝其他模板</el-button>
            <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
          </div>
          
          <!-- <el-input v-model="templateNameData.name" style="margin-top: 0px;width: 200px" placeholder="模板名称"></el-input> -->
          <el-button type="primary" size="medium" class="operator-btn" style="margin-right: 0px;" @click="handleUpdates('save')">
            <!-- <div v-if="templateNameData.id == null">
              添加
            </div> -->
            <div>
              保存
            </div>
          </el-button>
          <el-divider direction="vertical"></el-divider>
          <el-divider direction="vertical"></el-divider>
          <el-date-picker v-model="releaseDayTime" type="week" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"
            placeholder="选择周">
          </el-date-picker>
          <el-button type="primary" size="medium" class="operator-btn" style="margin-right: 0px;"
            @click="releaseWeekLesson">
            发布课程
          </el-button>
        </div>

      </el-card>
      <div style="margin-top: 22px;">
        <div style="display: flex;">
          <div class="xuaj">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link" style="color: #0E6FB8;">
                {{ commandName }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" style="height: 200px;overflow-y: auto;">
                <el-dropdown-item :command="item.name + ',' + item.id" v-for="item in allScheTemplates" :key="item.id">{{
                  item.name }} <div style="margin-left: 10px;" @click.stop="clickRemove(item)">删除</div></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="zho">
            周一
          </div>
          <div class="zho">
            周二
          </div>
          <div class="zho">
            周三
          </div>
          <div class="zho">
            周四
          </div>
          <div class="zho">
            周五
          </div>
          <div class="zho">
            周六
          </div>
          <div class="zho">
            周日
          </div>
        </div>
        <div style="height: 600px;overflow-y: auto;">
        <div style="background-color: #fff;display: flex;">
          <div class="forenoon" :style="antemeridians ? 'padding:50px 0px;' : ''">上午</div>
          <div v-for="(v, int) in templateNameData.schedulingData" class="antemeridian">
            <div class="ackemma" v-for="(s, index) in v.timeRangMorning">
              <div class="ackemma-top">
                <div style="display: flex;align-items: center;">
                  <div style="margin-right: 6px;">{{ s.startTime }}~{{ s.endTime }}</div>
                  <div>{{ s.lesson.name }}</div>
                </div>
                <el-checkbox v-model="s.checked"></el-checkbox>
              </div>
              <div class="ackemma-cent">
                <div style="margin-right: 20px;">
                  课容量:{{ s.maxNum }}
                </div>
                <div>
                  区域:{{ s.classroomNam }}
                </div>
              </div>
              <div class="ackemma-btn">
                教师:{{ s.teachers.headThacherName }}、{{ s.assistantNm }}
              </div>
            </div>
          </div>
        </div>
        <div style="background-color: #fff;display: flex;">
          <div class="forenoon" :style="antemeridians ? 'padding:50px 0px;' : ''">下午</div>
          <div v-for="(v, int) in templateNameData.schedulingData" class="antemeridian">
            <div class="ackemma" v-for="(s, index) in v.timeRangAfternoon">
              <div class="ackemma-top">
                <div style="display: flex;align-items: center;">
                  <div style="margin-right: 6px;">{{ s.startTime }}~{{ s.endTime }}</div>
                  <div>{{ s.lesson.name }}</div>
                </div>
                <el-checkbox v-model="s.checked"></el-checkbox>
              </div>
              <div class="ackemma-cent">
                <div style="margin-right: 20px;">
                  课容量:{{ s.maxNum }}
                </div>
                <div>
                  区域:{{ s.classroomNam }}
                </div>
              </div>
              <div class="ackemma-btn">
                教师:{{ s.teachers.headThacherName }}、{{ s.assistantNm }}
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <!-- <div class="title-container" shadow="never">
          <div class="title-con">
            <i class="el-icon-set-up"></i>
            <span style="margin-left: 5px;">日期</span>
          </div>
        </div>
        <el-container class="class-bs-root-container">
          <el-card class="class-s-card-date" v-for="item in templateNameData.schedulingData" :key="item.date" >
            <div style="font-size: 15px">
              {{item.dateDes}}
            </div>
          </el-card>
        </el-container> -->
    <!--为了初始化位置-->
    <!--上午的-->
    <!-- <div class="class-afternoon"  style=" margin-bottom: 0px;">
          <div class="title-container" shadow="never">
            <div class="title-con">
              <i class="el-icon-set-up"></i>
              <span style="margin-left: 5px;">上午</span>
            </div>
          </div>
          <div class="class-bs-root-container">
            <div v-for="(item,dayIndex) in templateNameData.schedulingData" :key="item.date" class="class-s-day">
              <div v-for="(item,timeIndex) in item.timeRangMorning" :key="item.id" >
                <el-card class="class-s-card">
                  <el-row>
                    <span class="class-s-card-lesson">{{item.lesson.name}}</span>
                  </el-row>
                  <el-row>
                    <span class="class-s-card-lesson">{{item.type}}</span>
                  </el-row>
                  <el-row>
                    <span class="class-s-card-time">{{item.startTime}} - {{item.endTime}}</span>
                  </el-row>
                  <el-row>
                    <span class="class-s-card-children">容纳量:{{item.maxNum}}</span>
                  </el-row>
                  <el-row>
                    <span class="class-s-card-children">主教课容量:{{item.teachers.headTeacherBookNum}}</span>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <span class="class-s-card-children">{{item.teachers.headThacherName}}</span>
                    </el-col>
                    <el-col :span="12">
                      <span class="class-s-card-children">{{item.teachers.assistantTeacherName}}</span>
                    </el-col>
                    <el-col :span="12">
                      <span class="class-s-card-children">教室:{{item.classroomName}}</span>
                    </el-col>
                  </el-row>
                  <el-button style="margin-top: 10px;margin-right: 0px;" type="warning" class="operator-btn2" size="mini"  @click="handleDeleteOne(item,1,dayIndex,timeIndex)">删除时间段</el-button>
                </el-card>
              </div>
            </div>
          </div>
        </div> -->
    <!--下午的-->
    <!-- <div class="class-afternoon"  style="margin-bottom: 20px;">
          <div class="title-container" shadow="never">
            <div class="title-con">
              <i class="el-icon-set-up"></i>
              <span style="margin-left: 5px;">下午</span>
            </div>
          </div>
          <div class="class-bs-root-container" >
            <div v-for="(item,dayIndex) in templateNameData.schedulingData" :key="item.date" class="class-s-day">
              <div  v-for="(item,timeIndex) in item.timeRangAfternoon" :key="item.id" >
                <el-card  class="class-s-card">
                  <el-row>
                    <span class="class-s-card-lesson">{{item.lesson.name}}</span>
                  </el-row>
                  <el-row>
                    <span class="class-s-card-lesson">{{item.type}}</span>
                  </el-row>
                  <el-row>
                    <span class="class-s-card-time">{{item.startTime}} - {{item.endTime}}</span>
                  </el-row>
                  <el-row>
                    <span class="class-s-card-children"> 总课容量:{{item.maxNum}}</span>
                  </el-row>
                  <el-row>
                    <span class="class-s-card-children">主教课容量:{{item.teachers.headTeacherBookNum}}</span>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <span class="class-s-card-children">{{item.teachers.headThacherName}}</span>
                    </el-col>
                    <el-col :span="12">
                      <span class="class-s-card-children">{{item.teachers.assistantTeacherName}}</span>
                    </el-col>
                    <el-col :span="12">
                      <span class="class-s-card-children">教室:{{item.classroomName}}</span>
                    </el-col>
                  </el-row>
                  <el-button style="margin-top: 10px;margin-right: 0px;" type="warning" class="operator-btn2" size="mini" @click="handleDeleteOne(item,2,dayIndex,timeIndex)">删除时间段</el-button>
                </el-card>
              </div>
            </div>
          </div>
        </div> -->
    <!-- <el-card>
          
        </el-card> -->
    <!-- </el-tab-pane> -->
    <!-- <el-tab-pane label="店铺设置" name="second"> -->
    <!-- <store-rest ref="refrerCFRest" :lesson-template-id="lessonTemplateId" :key="refrerCFRest"></store-rest> -->
    <!-- </el-tab-pane> -->
    <!-- <el-tab-pane label="课程发布列表" name="third"> -->
    <div v-else>
      <ReleaseLessonRecordFc :all-worker="allWorker"></ReleaseLessonRecordFc>
    </div>

    <!-- </el-tab-pane> -->
    <!-- </el-tabs> -->
    <el-dialog title="拷贝模板" :visible.sync="visibleDlgCopy" width="50%" center>
      <el-form ref="baseRef" label-width="140px">
        <el-form-item label="选择课表" prop="title">
          <el-select v-model="srcTemplateId" placeholder="请选择" style="width: 300px;">
            <el-option v-for="item in allScheTemplatesForCopy" :disabled="item.name == commandName
              " :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgCopy = false">取消</el-button>
        <el-button type="primary" @click="handleCopyOtherTemplate()">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="添加排班" :visible.sync="visibleDlgAdd" width="50%" center>
      <div>
        <el-form ref="registerRef" label-width="150px">
          <!-- <el-card style="margin-top: -20px;"> -->
          <el-form-item label="日期选择:">
            <el-checkbox-group v-model="dayIndexList">
              <el-checkbox v-for="item in templateNameData.schedulingData " :label="item.dayIndex" :key="item.dayIndex">{{
                item.dateDes }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <div style="display: flex;">
            <el-form-item label="课程选择:">
              <el-select v-model="addData.optionsLessonValue" placeholder="请选择">
                <el-option v-for="item in qlLeveList" :key="item.id" :label="item.lessonName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上课时间段:">
              <el-time-picker style="width: 150px" v-model="addData.addTime.start" format="HH:mm" value-format="HH:mm"
                :picker-options="{ selectableRange: '00:00:00- 23:59:59' }" placeholder="上课时间">
              </el-time-picker>
              <span>-</span>
              <el-time-picker style="width: 150px" v-model="addData.addTime.end" format="HH:mm" value-format="HH:mm"
                :picker-options="{ selectableRange: '00:00:00- 23:59:59' }" placeholder="下课时间">
              </el-time-picker>
            </el-form-item>
          </div>

          <!-- </el-card> -->
          <!-- <el-card style="margin-top: 10px;"> -->
          <!-- <span>课容量</span> -->
          <div style="display: flex;">
            <el-form-item label="位置:">
              <el-select v-model="classroomId" placeholder="请选择">
                <el-option v-for="item in selectAllList" :key="item.id" :label="item.classroomName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="总课容量:">
              <el-input-number v-model="addData.maxNum"></el-input-number>
            </el-form-item>
          </div>
          <div style="display: flex;">
            <el-form-item label="主教师:">
              <el-select v-model="headThacher" placeholder="请选择">
                <el-option v-for="item in allWorker" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="主教课容量:">
              <el-input-number v-model="headTeacherBookNum"></el-input-number>
            </el-form-item>
          </div>
          <!-- 
          <el-form-item label="教室:">
            <el-select v-model="classroomId" placeholder="教室" clearable style="width: 300px;">
              <el-option v-for="item in allClassroom" :key="item.id" :label="item.classroomName" :value="item.id" />
            </el-select>
          </el-form-item> -->
          <!-- </el-card> -->
          <!-- <el-card style="margin-top: 10px;"> -->
          <!-- <span>教练信息</span> -->
          <div>
            <el-form-item label="助教:">
              <!-- <el-select v-model="assistantTeacher" placeholder="请选择">
                <el-option v-for="item in allWorker" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select> -->
              <div style="display: flex;flex-wrap: wrap;">
                <div style="display: flex;align-items: center;margin-bottom: 10px;" v-for="(v, index) in course.teaching">
                  <el-select v-model="v.assistant" placeholder="请选择">
                    <el-option v-for="item in allWorker" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                  <img v-if="index == 0" src="../../../statics/imgs/jh.png" alt="" @click="clickjj"
                    style="width: 25px;margin-left: 10px;height: 25px;margin-right: 40px;">
                  <img v-else src="../../../statics/imgs/jih.png" alt="" @click="clickjs(index)"
                    style="margin-right: 40px;width: 25px;margin-left: 10px;height: 25px;">
                </div>
              </div>
            </el-form-item>
          </div>

          <!-- </el-card> -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgAdd = false">取消</el-button>
        <el-button type="warning" @click="handleAddOne()">添加</el-button>
      </span>
    </el-dialog>

    <!-- 创建课表 -->
    <el-dialog title="创建课表" :visible.sync="schedule" width="30%" :center="false">
      <div style="text-align: left;color: red;font-size: 16px; margin-bottom: 10px;">
        已有课表
      </div>
      <el-form ref="baseRef" label-width="80px">
        <div v-for=" (v, index) in allScheTemplates" :key="index">
          <el-form-item label="课表名称" prop="title">
            <el-input disabled v-model="v.name"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div style="text-align: left;color: red;font-size: 16px; margin-bottom: 10px;">
        创建新课表
      </div>
      <el-form ref="baseRef" label-width="80px">
        <el-form-item label="课表名称">
          <el-input v-model="templateNameData.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="schedule = false">取消</el-button>
        <el-button type="primary" @click="handleUpdates('submit')">确认</el-button>
      </span>
    </el-dialog>

    <!-- 课表删除 -->
    <el-dialog title="课表删除" :visible.sync="remove" width="30%" :center="false">
      <el-form ref="baseRef" label-width="80px">
        <el-form-item label="课程ID" prop="title">
          <el-input disabled v-model="coursest.id"></el-input>
        </el-form-item>
        <el-form-item label="模板名称" prop="title">
          <el-input disabled v-model="coursest.name"></el-input>
        </el-form-item>
      </el-form>
      <span style="text-align: center;">
        <el-button type="primary" @click="delteMplate()">确认</el-button>
        <el-button @click="remove = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import messageUtils from "../../../utils/messageUtils";
import commonUtils from "../../../utils/commonUtils";
import timeUtils from "../../../utils/timeUtils";
import { delTemplate, verify, copyTemplate, selectSchedule, updateSchedule,addnew, qlLevelLesson, selectAllGET, selectList } from "../../../api/scheduleTimeTemplate";
import globaldata from "../../../utils/globaldata";
import { releaseWeekLesson } from "../../../api/StoreReleaseLesson";
import { getStoreRestDay } from "../../../api/StoreSetting";
import enumsUtil from "../../../utils/enumsUtil";
import StoreRest from "../component/StoreRest";
import SchedulingFC from "./components/SchedulingFC";
import ReleaseLessonRecordFc from "./components/ReleaseLessonRecordFc";
export default {
  components: { ReleaseLessonRecordFc, SchedulingFC, StoreRest },
  data() {
    return {
      coursest: {
        name: '',
        id: ''
      },
      commandName: '当前课表名称', // 当前课表名称
      antemeridians: true,// 上午
      qlLeveList: [],//查询当前门店课程
      selectAllList: [], // 查询当前门店教室
      selectListLis: [], // 查询亲子排课所有模板
      allWorkerList: [], // 助教
      course: {
        date: [], // 日期选择
        curriculum: "", //课程选择
        timeStart: '',//上课时间
        timeEnd: '',//下课时间
        addres: '',// 位置
        capacity: '', //总课容量
        headThacher: '',//主教师
        headTeacherBookNum: '', // 主教课容量
        teaching: [{    // 助教
          assistant: ''
        }]
      },
      remove: false,// 删除弹窗
      schedule: false,// 创建课表弹窗
      ReleaseLesson: true,
      checked: true,
      activeName: 'first',
      lessonTemplateId: enumsUtil.lessonTemplateIdCF(),
      visibleDlgAdd: false, // 添加课程弹窗
      visibleDlgCopy: false,
      refrerCFRest: '',
      btTitle: "保存",
      dayIndexList: [],
      addData: {
        maxNum: 0,//最大人数
        addTime: {
          start: "",
          end: ""
        },
        optionsLessonValue: "",
        position: '',
        lessonTemplateBussnessId: "",//课程业务 亲子游 基础游
        workers: [],
      },

      templateNameData: {
        id: null,
        name: "",//模板名称
        schedulingData: [
          {
            id: null,
            dateDes: '周一',
            dayIndex: 0,
            scheduleTimeTemplateId: null,
            timeRangMorning: [],
            timeRangAfternoon: [],
            classroomId: 0,
          },
          {
            id: null,
            dateDes: '周二',
            dayIndex: 1,
            scheduleTimeTemplateId: null,
            timeRangMorning: [],
            timeRangAfternoon: [],
            classroomId: 0,
          },
          {
            id: null,
            dateDes: '周三',
            dayIndex: 2,
            scheduleTimeTemplateId: null,
            timeRangMorning: [],
            timeRangAfternoon: [],
            classroomId: 0,
          },
          {
            id: null,
            dateDes: '周四',
            dayIndex: 3,
            scheduleTimeTemplateId: null,
            timeRangMorning: [],
            timeRangAfternoon: [],
            classroomId: 0,
          },
          {
            id: null,
            dateDes: '周五',
            dayIndex: 4,
            scheduleTimeTemplateId: null,
            timeRangMorning: [],
            timeRangAfternoon: [],
            classroomId: 0,
          },
          {
            id: null,
            dateDes: '周六',
            dayIndex: 5,
            scheduleTimeTemplateId: null,
            timeRangMorning: [],
            timeRangAfternoon: [],
            classroomId: 0,
          },
          {
            id: null,
            dateDes: '周日',
            dayIndex: 6,
            scheduleTimeTemplateId: null,
            timeRangMorning: [],
            timeRangAfternoon: [],
            classroomId: 0,
          }

        ],
      },

      curWork: "",
      //所有员工
      allWorker: [

      ],
      headThacher: "", //主教
      headTeacherBookNum: "", //主教最大课容量
      assistantTeacher: "", //助教
      allClassroom: [],
      classroomId: '',
      allScheTemplates: [

      ], //店铺所有的排班模板列表
      //店铺等级课程
      storeLevelLesson: [],
      //店铺可以使用的模板课程
      storeLessons: [],

      queryParam: {
        name: ""
      },
      releaseDayTime: "", //发布课程日期


      restDays: [],
      srcTemplateId: null,

      allScheTemplatesForCopy: [],
      isVip: globaldata.getAdminStore().isVip,
    }

  },

  created() {
    globaldata.getStoreScheduingTempLate(this.getStoreScheduingTempLate);
    globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
    globaldata.getStoreLevelLesson(this.getStoreLevelLesson);
    globaldata.getStoreLessonTemplate(this.getStoreLessonTemplate);
    globaldata.getClassroom(this.getClassroom);
  },

  beforeMount() {


  },
  methods: {
    clickRemovedt() {
      let self = this
      let osfd = []
      console.log(self.templateNameData.schedulingData,'self.templateNameData.schedulingData')
      self.templateNameData.schedulingData.forEach(item => {
        for(var i = item.timeRangAfternoon.length ;i>0;i--){
          if (item.timeRangAfternoon[i-1].checked == true) {
            self.$delete(item.timeRangAfternoon,i-1)
          }
        }
        for(var i = item.timeRangMorning.length ;i>0;i--){
          if (item.timeRangMorning[i-1].checked == true) {
            self.$delete(item.timeRangMorning,i-1)
          }
        }
      })
    },
    clickRemove(id) {
      this.coursest = id
      if (this.coursest.id) {
        this.remove = true
      } else {
        messageUtils.errorMsg(this, "请先选择课表");
      }
    },
    handleCommand(command) {
      let ods = command.split(',')
      this.templateNameData.name = ''
      this.templateNameData.id = ods[1]
      this.coursest.name = ods[0]
      this.coursest.id = ods[1]

      this.commandName = ods[0]
      this.onChaneTemplate(ods[1])
      console.log(command, ods, 'command===========')
    },
    getClassroom(list) {
      this.allClassroom.push({ id: 0, classroomName: "无" })
      this.allClassroom = this.allClassroom.concat(list);
      // console.info('allClassroom');
      // console.info(this.allClassroom);
    },
    getClassroomById(id) {
      //console.info(this.allClassroom.length);
      for (let i = 0; i < this.allClassroom.length; ++i) {
        if (this.allClassroom[i].id == id) {
          //console.info(this.allClassroom[i].classroomName);
          return this.allClassroom[i].classroomName;
        }
      }
      return ""
    },
    getStoreLevelLesson(data) {
      this.storeLevelLesson = data;
    },
    getStoreWorkersInfo(list) {
      this.allWorker.push({ id: null, name: "无" })
      this.allWorker = this.allWorker.concat(list);
    },
    getStoreLessonTemplate(list) {
      this.storeLessons = list;
    },
    getWorker(id) {
      for (let i = 0; i < this.allWorker.length; ++i) {
        if (this.allWorker[i].id == id) {
          return this.allWorker[i].name;
        }
      }
      return ""
    },

    getStoreScheduingTempLate(list) {
      this.allScheTemplates = [];
      this.allScheTemplatesForCopy = [];
      for (let i = 0; i < list.length; ++i) {
        this.allScheTemplates.push(
          {
            id: list[i].id,
            name: list[i].name,
          }
        )
        this.allScheTemplatesForCopy.push(
          {
            id: list[i].id,
            name: list[i].name,
          }
        )
      }
      // this.allScheTemplates.push(
      //   {
      //     id: null,
      //     name: "添加新模板",
      //   }
      // )
    },
    // 删除确认
    delteMplate() {
      delTemplate({ id: this.coursest.id }).then((res) => {
        // console.log(res, '===========')
        if (res.code == 20000) {
          messageUtils.successMsg(this, "删除成功")
          this.commandName = '当前课表名称'
          this.onChaneTemplate(null)
          globaldata.getStoreScheduingTempLate(this.getStoreScheduingTempLate);
          this.remove = false
        }
      })
    },
    //选择一个员工
    onChaneWork() {
      for (let i = 0; i < this.addData.workers.length; ++i) {
        let worker = this.addData.workers[i];
        if (worker.id == this.curWork.id) {
          this.curWork = null;
          messageUtils.errorMsg(this, "员工重复了");
          return;
        }
      }
      this.addData.workers.push(this.curWork)
      this.curWork = null;

    },
    // 增加助教
    clickjj() {
      this.course.teaching.push({ assistant: '' })
    },
    // 减少助教
    clickjs(index) {
      console.log(index, '=======')
      // this.course.teaching.push({ assistant: '' })
      this.$delete(this.course.teaching, index, 1)
    },
    handleAddoneDlg() {
      this.resetAddData();
      this.qlLevel() ////查询当前门店课程
      this.selectAll() //查询当前门店教室
      this.selectLi()// 查询亲子排课所有模板
      this.visibleDlgAdd = true;
    },
    ////查询当前门店课程
    qlLevel() {
      qlLevelLesson({ storeFrontId: globaldata.getAdminStore().storeFrontId }).then((res) => {
        // console.log(res, 'res================')
        if (res.code == 20000) {
          this.qlLeveList = res.data
        }
      })
    },
    //查询当前门店教室
    selectAll() {
      selectAllGET({ shopFrontId: globaldata.getAdminStore().storeFrontId }).then((res) => {
        // console.log(res, 'res================')
        if (res.code == 20000) {
          this.selectAllList = res.data
        }
      })
    },
    // 查询亲子排课所有模板
    selectLi() {
      selectList({ storeFrontId: globaldata.getAdminStore().storeFrontId }).then((res) => {
        // console.log(res, 'res================')
        if (res.code == 20000) {
          this.selectListLis = res.data
        }
      })
    },
    //重置添加的排班时间段数据
    resetAddData() {
      this.classroomId = ''
      this.headThacher = ''
      this.headTeacherBookNum = 0
      this.dayIndexList = []
      this.course.teaching = [{
        assistant: ''
      }]
      this.addData = {
        addDay: "",
        dayIndex: -1,
        maxNum: 0,//最大人数
        addTime: {
          start: "",
          end: ""
        },
        optionsLessonValue: null,
        workers: [],
      }
    },
    handleAddOne() {
      let assistantTeacher, headTeacher;
      assistantTeacher = this.headThacher
      this.course.teaching.forEach((item) => {
        headTeacher = headTeacher ? headTeacher + ',' + item.assistant : item.assistant
      })
      console.log(this.headThacher, this.course.teaching, headTeacher, 'course.teaching====')
      verify({ headTeacher: assistantTeacher, assistantTeacher: headTeacher }).then((res) => {
        if (res.code != 20000) {
        } else {

          for (var k = 0, length = this.dayIndexList.length; k < length; k++) {
            let dayIndex = this.dayIndexList[k]
            if (commonUtils.isStringNull(this.addData.addTime.start)
              || commonUtils.isStringNull(this.addData.addTime.end)) {
              messageUtils.errorMsg(this, "请选择时间")
              return;
            }
            //判断是否和当天的排班有时间上的冲突
            let start = timeUtils.transTimeHMInt(this.addData.addTime.start);
            let end = timeUtils.transTimeHMInt(this.addData.addTime.end);

            if (this.addData.optionsLessonValue == null) {
              messageUtils.errorMsg(this, "请选择课程");
              return;
            }
            let schedulingDay = this.templateNameData.schedulingData[dayIndex];
            if (commonUtils.isObjectNull(schedulingDay)) {
              messageUtils.errorMsg(this, "选择错误了，重新选择日期");
              return;
            }

            //亲子游的判断
            if (this.addData.maxNum <= 0) {
              messageUtils.errorMsg(this, "请设置最大上课人数");
              return;
            }
            if (!commonUtils.isStringNull(this.headThacher) && !commonUtils.isStringNull(this.assistantTeacher)) {
              if (this.headThacher == this.assistantTeacher) {
                messageUtils.errorMsg(this, "主教和助教不能设置为同一人");
                return;
              }
            }

            let timeRang = null;
            if (start < 1200) {
              //上午
              timeRang = schedulingDay.timeRangMorning;
            } else {
              //下午
              timeRang = schedulingDay.timeRangAfternoon;
            }
            if (timeRang.length <= 0) {
              //只有一个那就直接插入了
              this.insterOne(timeRang, 0);
              continue;
            }
            //直接在下面排序 从后到前遍历
            for (let i = timeRang.length - 1; i >= 0; --i) {
              // let rangeStart = timeUtils.transTimeHMInt(timeRang[i].startTime);
              // let rangeEnd = timeUtils.transTimeHMInt(timeRang[i].endTime);
              // if ((start < rangeEnd && start>  rangeStart) || (end < rangeEnd && end>rangeStart)
              //   || (start == rangeStart ||  end  == rangeEnd)) {
              //   messageUtils.errorMsg(this,"时间段有冲突,请重新选择时间段");
              //   return;
              // }
              let nt = timeUtils.transTimeHMInt(timeRang[i].endTime);
              if (start >= nt) {
                this.insterOne(timeRang, i + 1);
                break;
              }
              if (i == 0) {
                this.insterOne(timeRang, 0);
              }
            }
          }
          //   console.log(schedulingDay, assistantTeacher,'schedulingDay===========')
          // }
          // console.log(this.templateNameData.schedulingData, 'templateNameData.schedulingData')

          // return
          messageUtils.successMsg(this, "添加成功")
          // this.antemeridians = false
          this.visibleDlgAdd = false
        }
      })
    },
    onDelWork(worker) {
      for (let i = 0; i < this.addData.workers.length; ++i) {
        let item = this.addData.workers[i];
        if (worker.id == item.id) {
          this.addData.workers.splice(i, 1);
          return;
        }
      }
    },
    insterOne(timeRang, index) {
      if (commonUtils.isStringNull(this.addData.addTime.start) || commonUtils.isStringNull(this.addData.addTime.end)) {
        messageUtils.errorMsg(this, "请选择时间段");
        return;
      }
      let levelLesson = this.getStoreLessonById(this.addData.optionsLessonValue);
      if (commonUtils.isObjectNull(levelLesson)) {
        return;
      }
      let classroomNam
      this.selectAllList.forEach((ite) => {
        if (ite.id == this.classroomId) {
          classroomNam = ite.classroomName
        }
      })
      let assistantNm
      this.allWorker.forEach((item, index) => {
        if (item.id == this.course.teaching[0].assistant) {
          assistantNm = item.name
        }
      })
      let data = {
        lesson: {
          id: levelLesson.id,
          name: levelLesson.lessonName
        },
        startTime: this.addData.addTime.start,
        endTime: this.addData.addTime.end,
        maxNum: this.addData.maxNum,
        workers: this.addData.workers,
        checked: false,
        teachers: {
          headThacher: this.headThacher,
          headTeacherBookNum: this.headTeacherBookNum,
          assistantTeacher: this.course.teaching,
          headThacherName: this.getWorker(this.headThacher),
          assistantTeacherName: this.getWorker(this.assistantTeacher),
          teaching: this.course.teaching
        },
        classroomId: this.classroomId,
        classroomNam: classroomNam,
        assistantNm: assistantNm
      }

      timeRang = timeRang.splice(index, 0, data);
      console.log("添加一个排班", data)
    },

    getStoreLessonById(id) {
      for (let i = 0; i < this.storeLevelLesson.length; ++i) {
        if (id == this.storeLevelLesson[i].id) {
          return this.storeLevelLesson[i];
        }
      }
      return "";
    },


    /**
     * 刷新模板数据
     */
    refreshData(data) {
      this.onDataToView(data);
    },

    /**
     * 数据刷新到页面显示
     */
    onDataToView(data) {
      this.resetData();
      this.templateNameData.id = data.id;
      this.queryParam.name = data.name;
      this.templateNameData.name = '';
      let list = data.list;
      for (let i = 0; i < this.templateNameData.schedulingData.length; ++i) {
        let schedulingData = this.templateNameData.schedulingData[i];
        schedulingData.timeRangMorning = [];
        schedulingData.timeRangAfternoon = [];
        schedulingData.id = list[i].id;
        schedulingData.scheduleTimeTemplateId = list[i].scheduleTimeTemplateId;
        schedulingData.dayIndex = list[i].dayIndex;
        let dayIndexData = this.getDayIndexData(list, schedulingData.dayIndex);
        if (commonUtils.isObjectNull(dayIndexData)) {
          continue;
        }
        //将数据刷新到
        let times = JSON.parse(dayIndexData.times);
        console.log(times, 'list =============')

        for (let i = 0; i < times.length; ++i) {
          let ar = times[i].timeRange.split("_");
          if (commonUtils.isObjectNull(ar) || ar.length != 2) {
            continue;
          }

          let startSort = timeUtils.transTimeHMInt(ar[0]);
          let lessonId = times[i].lessonId;
          let lessonName = "";
          if (!commonUtils.isObjectNull(lessonId)) {
            lessonName = this.getStoreLessonById(lessonId).lessonName;
          }

          let teachers = times[i].teachers;
          if (commonUtils.isStringNull(teachers)) {
            teachers = {

            }
          } else {
            teachers.headThacherName = this.getWorker(teachers.headThacher);
            teachers.assistantTeacherName = this.getWorker(teachers.assistantTeacher);
          }
          //  let ovj =  teachers.assistantTeacher.split(',')
          //  this.
          let t = {
            lesson: {
              id: lessonId,
              name: lessonName
            },
            startSort: startSort,
            startTime: ar[0],
            endTime: ar[1],
            workers: times[i].workers,
            teachers: teachers,
            maxNum: times[i].maxNum,
            // classroomName: this.getClassroomById(times[i].classroomId),
            classroomId: times[i].classroomId,
            classroomNam: times[i].classroomNam,
            assistantNm: times[i].assistantNm,
            checked: false,
            count: times[i].count,
          }
          if (startSort < 1200) {
            //上午
            schedulingData.timeRangMorning.push(t);
          } else {
            //下午
            schedulingData.timeRangAfternoon.push(t);
          }
        }
      }
    },

    getDayIndexData(list, dayIndex) {
      for (let i = 0; i < list.length; ++i) {
        if (list[i].dayIndex == dayIndex) {
          return list[i];
        }
      }
    },

    handleDeleteOne(item, v, dayIndex, timeIndex) {
      let timeRang = null;
      if (v == 1) {
        //上午
        timeRang = this.templateNameData.schedulingData[dayIndex].timeRangMorning;
      } else if (v == 2) {
        //下午
        timeRang = this.templateNameData.schedulingData[dayIndex].timeRangAfternoon;
      }
      timeRang.splice(timeIndex, 1);
    },

    /**
     * 重置一下数据
     */
    resetData() {
      this.templateNameData.id = null;
      this.templateNameData.name = "";
      this.queryParam.name = "";
      this.resetScheData()

    },
    resetScheData() {
      for (let i = 0; i < this.templateNameData.schedulingData.length; ++i) {
        this.templateNameData.schedulingData[i].id = null;
        this.templateNameData.schedulingData[i].scheduleTimeTemplateId = null;
        this.templateNameData.schedulingData[i].timeRangMorning = [];
        this.templateNameData.schedulingData[i].timeRangAfternoon = [];
      }
    },

    /**
     * 添加与保存
     */
    handleUpdates(currentState) {
      console.log(this.allScheTemplates,'this.allScheTemplates======',this.templateNameData.id)
      // if (commonUtils.isStringNull(this.templateNameData.name)) {
      //   messageUtils.errorMsg(this, "请选择课表")
      //   return;
      // }
      console.log(this.templateNameData.name,'this.templateNameData.name')

      let maxNum = 20;
      if (this.allScheTemplates.length > maxNum + 1) {
        //因为初始化的时候加了一个
        messageUtils.errorMsg(this, "最多只能创建 " + maxNum + "个模板")
        return;
      }
      

      let data = {
        id: this.templateNameData.id,
        name: this.templateNameData.name ? this.templateNameData.name : this.commandName ,
        // name: this.templateNameData.name,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        adminId: globaldata.getAdminStore().id,
        list: []
      };
      for (let i = 0; i < this.templateNameData.schedulingData.length; ++i) {
        let sche = this.templateNameData.schedulingData[i];
        let scheParam = {
          id: sche.id,
          dayIndex: sche.dayIndex,
          scheduleTimeTemplateId: sche.scheduleTimeTemplateId,
          times: "",
        }

        let timeRangArray = [];
        for (let m = 0; m < sche.timeRangMorning.length; ++m) {
          let timeRang = sche.timeRangMorning[m];
          let str = timeRang.startTime + '_' + timeRang.endTime;
          timeRang.teachers.assistantTeacher = timeRang.teachers.teaching
          let assistantTeacher = ''
          timeRang.teachers.assistantTeacher.forEach((item) => {
            assistantTeacher = assistantTeacher ? assistantTeacher + ',' + item.assistant : item.assistant
          })
          let timeRangdata = {
            lessonId: timeRang.lesson.id,//课程名
            workers: timeRang.workers, //教练员工
            teachers: {
              headThacher: timeRang.teachers.headThacher,
              headTeacherBookNum: timeRang.teachers.headTeacherBookNum,
              assistantTeacher: assistantTeacher,
              teaching: timeRang.teachers.teaching
            },
            maxNum: timeRang.maxNum,  //最大人数
            timeRange: str,//上课时间段
            classroomId: timeRang.classroomId,
            classroomNam: timeRang.classroomNam,
            assistantNm: timeRang.assistantNm,
          }
          timeRangArray.push(timeRangdata)

        }
        for (let m = 0; m < sche.timeRangAfternoon.length; ++m) {
          let timeRang = sche.timeRangAfternoon[m];
          let str = timeRang.startTime + '_' + timeRang.endTime;
          timeRang.teachers.assistantTeacher = timeRang.teachers.teaching
          let assistantTeacher = ''
          console.log(timeRang.teachers.assistantTeacher, ';==============assistantTeacher')
          timeRang.teachers.assistantTeacher.forEach((item) => {
            assistantTeacher = assistantTeacher ? assistantTeacher + ',' + item.assistant : item.assistant
          })
          let timeRangdata = {
            lessonId: timeRang.lesson.id,//课程名
            workers: timeRang.workers, //教练员工
            teachers: {
              headThacher: timeRang.teachers.headThacher,
              headTeacherBookNum: timeRang.teachers.headTeacherBookNum,
              assistantTeacher: assistantTeacher,
              teaching: timeRang.teachers.teaching
            },
            maxNum: timeRang.maxNum,  //最大人数
            timeRange: str,//上课时间段
            classroomId: timeRang.classroomId,
            classroomNam: timeRang.classroomNam,
            assistantNm: timeRang.assistantNm,
          }
          timeRangArray.push(timeRangdata)
        }
        scheParam.times = (JSON.stringify(timeRangArray))

        data.list.push(scheParam);

      }
      // return
      const loading = this.myLoading();
      if(currentState == 'save'){
         
        updateSchedule(data).then(response => {
          loading.close();
          let data = response.data;
          console.log(response,'response=====111111')
          if (data == true) {
            this.commandName = '当前课表名称'
            messageUtils.successMsg(this, "保存成功");
            //重新刷新下
            globaldata.getStoreScheduingTempLate(this.getStoreScheduingTempLate);
            this.resetData();
          } else {
            messageUtils.successMsg(this, "保存失败");
          }

        })
      }else if(currentState == 'submit'){
       //判断重复名字或者已经存在
       for (let i = 0; i < this.allScheTemplates.length; ++i) {
          let name = this.allScheTemplates[i].name;
          if (this.templateNameData.id != null && this.templateNameData.id == this.allScheTemplates[i].id) {
            continue;
          }
          if (this.templateNameData.name == name) {
            messageUtils.errorMsg(this, "模板名字重复或者已经存在")
            return;
          }
        }
        addnew(data).then(response => {
          loading.close();
          // let data = response.data;
          console.log(response,'response=====222222')
          // if (data == true) {
          if(response.code == 20000){
            this.commandName = '当前课表名称'
            messageUtils.successMsg(this, "保存成功");
            //重新刷新下
            globaldata.getStoreScheduingTempLate(this.getStoreScheduingTempLate);
            this.resetData();
          } else {
            messageUtils.successMsg(this, "保存失败");
          }

        })
      }
      

      this.schedule = false
    },

    // 查询一个模板信息

    onChaneTemplate(val) {
      if (val == null) {
        //创建新模板
        this.resetData();
        return;
      }
      if (val > 0) {
        let param = {
          id: val
        }
        selectSchedule(param).then(response => {

          let data = response.data;
          if (!commonUtils.isObjectNull(data)) {
            this.refreshData(data)
          }
        })
      }
    },

    releaseWeekLesson() {
      console.log(this.templateNameData.id, 'this.templateNameData.id========')
      if (commonUtils.isObjectNull(this.templateNameData.id)) {
        messageUtils.errorMsg(this, "请选择一个已经存在的模板");
        return;
      }
      if (commonUtils.isStringNull(this.releaseDayTime)) {
        messageUtils.errorMsg(this, "请选择发布时间");
        return;
      }
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        scheTemplateId: this.templateNameData.id,
        dayTime: this.releaseDayTime,
        adminId: globaldata.getAdminStore().id,
      }
      const loading = this.myLoading();
      releaseWeekLesson(param).then(response => {
        loading.close();
        let data = response.data;
        if (data == true) {
          messageUtils.successMsg(this, response.message)
        } else {
          messageUtils.errorMsg(this, response.message)
        }
      })
    },

    handleChangeTab(tab) {
      if (this.activeName == "second") {
        this.getStoreRestDay();

      }

    },

    getStoreRestDay() {
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        lessonTemplateId: enumsUtil.lessonTemplateIdCF(),
      }

      getStoreRestDay(param).then(response => {
        let data = response.data;
        if (data != null) {
          this.$refs['refrerCFRest'].refreshData(data);

        }
      })
    },

    /**
     * 拷贝模板
     */
    copyOtherTemplate() {
      if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
      this.visibleDlgCopy = true;
    },

    /**
     * 拷贝模板 id ,模板名不能拷贝
     */
    handleCopyOtherTemplate() {

      let param = {
        srcTemplateId: this.srcTemplateId,
        tarTemplateId: this.templateNameData.id,
      }
      copyTemplate(param).then(response => {
        let data = response.data;
        if (!commonUtils.isObjectNull(data)) {
          this.onDataToView(data);
          this.visibleDlgCopy = false;
        }
      })

    }

  }
}
</script>
<style scoped>
/deep/ .el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: none;
}

/deep/ .el-tabs__item {
  height: 36px;
  color: #0e6eba;
  background: #cedef5;
  margin-right: 10px;
  border-radius: 4px;
  line-height: 36px;
  /* 卡片阴影 */
  box-shadow: 0px 0px 16px 4px rgba(238, 56, 35, 0.09);
}

/* /deep/ .el-tabs__item.is-active {
  color: #ffffff;
  text-align: center;
  background: linear-gradient(120.93deg, #1270b8 3.98%, #5aaeee 100%);
} */

/deep/ .el-dropdown-menu .el-popper {
  height: 200px;
  overflow-y: auto;
}

/deep/ .el-tabs__active-bar {
  display: none;
}

/deep/ .el-tabs__nav-wrap::after {
  display: none;
}

/deep/ .el-dialog--center {
  border: 2px solid #d0d0d0;
  border-radius: 10px;
}

/deep/ .el-dialog__header {
  border-radius: 10px;
  /* background: #f0f7ff; */
  text-align: left;
}

.top-con {
  width: 90%;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  text-align: center;
  margin-top: 5px;
  margin-bottom: 5px;
}

.class-bs-root-container {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  text-align: center;
  border: 1px solid #bdbdbd;
  border-radius: 8px;
  background: #FFFFFF;
  padding: 15px 0px 15px 0px;
}

.class-search-content-area {
  height: 100px;
}

.class-afternoon {
  display: flex;
  flex-direction: column;
  justify-content: start;
}

.class-s-day {
  width: 12%;
  height: auto;
  display: flex;
  flex-direction: column;
}

.class-s-card-date {
  width: 12%;
  height: 150px;
  font-size: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.class-s-card {
  margin-top: 4px;
  margin-top: 4px;
  width: 100%;
  height: 100%;
  text-align: center;
  font-size: 25px;
  background-color: #FFFFFF;
  border: 1px solid #d9d9d9;
}

.class-s-card-time {
  font-size: 18px;
  line-height: 35px;
  background-image: -webkit-linear-gradient(left, #0d6fb8, #63b1ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.class-s-card-children {
  text-align: left;
  font-size: 15px;
  line-height: 30px;
  background-image: -webkit-linear-gradient(left, #0d6fb8, #63b1ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  width: 100%;
}

.class-s-card-worker {
  margin-top: 0px;
  text-align: left;
  font-size: 15px;
}

.class-s-card-lesson {
  font-size: 18px;
  line-height: 35px;
  text-align: center;
  background-image: -webkit-linear-gradient(left, #0d6fb8, #63b1ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.class-bs-root {
  display: flex;
  flex-direction: column;
}

.class-worker-card {
  font-size: 15px;
  width: 100%;
  height: 20px;
}

.line {
  width: 100%;
  background-color: rgb(168, 168, 167);
  height: 1px;
  margin-top: 2px;
  margin-bottom: 1px;
}

.zho {
  width: 220px;
  height: 60px;
  line-height: 60px;
  background: #ECF3FD;
  font-size: 14px;
  font-weight: 400;
  color: #0E6FB8;
}

.xuaj {
  font-size: 14px;
  font-weight: 400;
  color: #0E6FB8;
  width: 130px;
  height: 60px;
  line-height: 60px;
  background: #ECF3FD;
  border-radius: 7px 0px 0px 0px;
}

.antemeridian {
  width: 220px;
  /* height: 60px;
  line-height: 60px; */
  font-size: 14px;
  font-weight: 400;
  color: #0E6FB8;
}

.forenoon {
  font-size: 14px;
  font-weight: 400;
  color: #0E6FB8;
  width: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
  background: #ECF3FD;
  border-radius: 8px;
}

.ackemma {
  margin: 10px;
  /* width: 190px;
  height: 90px; */
  background: #FFFFFF;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.04);
  border-radius: 10px;
  border: 1px solid #E0E0E0;
  padding: 10px;
}

.ackemma-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ackemma-cent {
  margin-top: 6px;
  color: #666666;
  display: flex;
  font-size: 14px;
}

.ackemma-btn {
  margin-top: 6px;
  color: #666666;
  font-size: 14px;
  text-align: left;
}

/deep/ .el-dropdown-menu__item {
  display: flex !important;
}
</style>



// WEBPACK FOOTER //
// src/views/my-store/scheduling-template/index.vue